import React from 'react';
import { Home } from '../pages/intro-pages/Home/Home';
import { Routes, Route } from 'react-router-dom';
import { FAQ } from '../pages/intro-pages/FAQ/FAQ';
import { UpdatePage } from '../pages/intro-pages/UpdatePage/UpdatePage';
import { Colors } from '../pages/visual-pages/Colors';
import { Graphics } from '../pages/visual-pages/Graphics';
import { Grid } from '../pages/visual-pages/Grid';
import { Icons } from '../pages/visual-pages/Icons';
import { Shadows } from '../pages/visual-pages/Shadows';
import { Typography } from '../pages/visual-pages/Typography/Typography';
import { ErrorPage } from '../cookbook-ui/custom-components/ErrorPage/ErrorPage';
// import { KitchenStarter } from '../pages/templates-pages/KitchenStarter/KitchenStarter';
// import { ReferenceApp } from '../pages/templates-pages/ReferenceApp/ReferenceApp';
import { MetricsPage } from '../pages/intro-pages/Metrics/MetricsPage';
import { UpcomingBreakingChanges } from '../pages/intro-pages/UpcomingBreakingChanges/UpcomingBreakingChanges';
// import { Pattern } from '../pages/Pattern/Pattern';
import { documentation } from '../utils/Documentation';
import { Category } from './Category';
import { DebugService } from './intro-pages/DebugService/DebugService';
import { UserInfo } from './hiddenPages/userInfo/UpdateUserInfo';

const categories = documentation.allCategories;
const categoryRoutes = categories.map((category) => <Route key={category} path={`/${category}`} element={<Category category={category} />} />);

export const AppRoutes = (
  <Routes>
    {/* Introduction */}
    <Route path="/" element={<Home />} />
    <Route path="/Home" element={<Home />} />
    <Route path="/FAQ" element={<FAQ />} />
    <Route path="/DebugService" element={<DebugService />} />
    <Route path="/Updates" element={<UpdatePage />} />
    <Route path="/Metrics" element={<MetricsPage />} />
    <Route path="/Upcoming-Breaking-Changes" element={<UpcomingBreakingChanges />} />
    {/* Visuals */}
    <Route path="/Colors" element={<Colors />} />
    <Route path="/Graphics" element={<Graphics />} />
    <Route path="/Grid" element={<Grid />} />
    <Route path="/Icons" element={<Icons />} />
    <Route path="/Shadows" element={<Shadows />} />
    <Route path="/Typography" element={<Typography />} />
    <Route path="/UserInfo" element={<UserInfo />} />

    {/* Templates */}
    {/* <Route path="/Kitchen-Starter" element={<KitchenStarter />} /> */}
    {/* <Route path="/Reference-App" element={<ReferenceApp />} /> */}
    {/* Patterns */}
    {/* <Route path="/Pattern/:id" element={<Pattern />} /> */}
    {/* Components */}
    {categoryRoutes}

    {/* 404 */}
    <Route path="" element={<ErrorPage title=":(" subtitle="Page Not Found" />} />
  </Routes>
);
